<template>
    <div class="mt-8">
        <div v-if="user.stripe_card_meta">
            <div class="mt-4">
                <div class="text-neutral-60">
                    Using card ending in:
                    <span class="font-semibold text-neutral-100">{{
                        cardInfo.last_4
                    }}</span>
                </div>
                <div class="text-neutral-60">
                    Expiration:
                    <span class="font-semibold text-neutral-100"
                        >{{ cardInfo.exp_month }}/{{ cardInfo.exp_year }}</span
                    >
                </div>
            </div>
        </div>
        <div>
            <div class="mt-2 flex">
                <div class="">
                    <new-modal
                        ref="updateCardInformationModal"
                        title="Add/Update Card Information"
                    >
                        <template #trigger>
                            <span class="btn btn-primary btn-sm inline-block"
                                ><i class="far fa-credit-card"></i>
                                Add/Update Card Information
                            </span>
                        </template>

                        <template #content>
                            <user-change-payment-card />
                        </template>
                    </new-modal>
                </div>
                <div class="" v-if="cardInfo">
                    <confirm-dialog
                        v-on:confirm="removeCard"
                        v-on:cancel=""
                        confirm-button-label="Remove Card"
                        cancel-button-label="Cancel"
                    >
                        <template #trigger>
                            <span
                                class="btn btn-warning btn-sm ml-4 inline-block"
                                ><i class="far fa-trash"></i> Remove Card</span
                            >
                        </template>
                        <template #content>
                            <div class="flex flex-col gap-4">
                                <div class="">
                                    Removing your card information will disable
                                    auto-renewal and your account will expire at
                                    the end of this billing cycle.
                                </div>
                                <div class="font-semibold">Are you sure?</div>
                            </div>
                        </template>
                    </confirm-dialog>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ConfirmDialog from "@/Components/ConfirmDialog";
import NewModal from "@/Components/NewModal";
import UserChangePaymentCard from "@/Components/UserChangePaymentCard";

export default {
    name: "UserPaymentMethod",
    components: {
        UserChangePaymentCard,
        ConfirmDialog,
        NewModal,
    },
    props: {},
    data() {
        return {
            user: this.$page.props.auth.user,
            cardInfo: this.$page.props.auth.user.stripe_card_meta,
        };
    },
    methods: {
        cancel() {},
        removeCard() {
            axios.get("/remove-all-payment-methods").then(function (response) {
                setTimeout(function () {
                    window.location.reload();
                }, 500);
            });
        },
    },
};
</script>
